import { render, staticRenderFns } from "./stockDetailDialog.vue?vue&type=template&id=4e57cf5a"
import script from "./stockDetailDialog.vue?vue&type=script&lang=js"
export * from "./stockDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e57cf5a')) {
      api.createRecord('4e57cf5a', component.options)
    } else {
      api.reload('4e57cf5a', component.options)
    }
    module.hot.accept("./stockDetailDialog.vue?vue&type=template&id=4e57cf5a", function () {
      api.rerender('4e57cf5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/addProductDialog/stockDetailDialog.vue"
export default component.exports